import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import TrackingMap from './TrackingMap';
import TrackingTMSMap from './TrackingTMSMap';

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/seguimiento/:token">
          <TrackingMap />
        </Route>

        <Route path="/seguimiento-tms/:token">
          <TrackingTMSMap />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;